/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nfp_Faq_1_AInputs */

const en_nfp_faq_1_a = /** @type {(inputs: Nfp_Faq_1_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You can launch a fully functional hub on the Base Operator tier with zero monthly fees. We only collect a small platform fee on processed donations or sales.`)
};

const es_nfp_faq_1_a = /** @type {(inputs: Nfp_Faq_1_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puedes lanzar un centro completamente funcional en el nivel Base Operator con cero tarifas mensuales. Solo cobramos una pequeña tarifa por donaciones procesadas.`)
};

const fr_nfp_faq_1_a = /** @type {(inputs: Nfp_Faq_1_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous pouvez lancer un hub entièrement fonctionnel sur le forfait Base Operator avec zéro frais mensuels. Nous ne prélevons qu'une petite commission de plateforme sur les dons ou les ventes traités.`)
};

const de_nfp_faq_1_a = /** @type {(inputs: Nfp_Faq_1_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du kannst auf der Base-Operator-Stufe einen voll funktionsfähigen Hub ohne monatliche Gebühren starten.`)
};

const id_nfp_faq_1_a = /** @type {(inputs: Nfp_Faq_1_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anda dapat meluncurkan hub yang berfungsi penuh pada paket Operator Dasar tanpa biaya bulanan. Kami hanya memungut biaya platform kecil dari donasi atau penjualan yang diproses.`)
};

/** @type {(inputs: Nfp_Faq_1_AInputs) => LocalizedString} */
const ja_nfp_faq_1_a = en_nfp_faq_1_a;

/** @type {(inputs: Nfp_Faq_1_AInputs) => LocalizedString} */
const zh_nfp_faq_1_a = en_nfp_faq_1_a;

/** @type {(inputs: Nfp_Faq_1_AInputs) => LocalizedString} */
const ar_nfp_faq_1_a = en_nfp_faq_1_a;

/** @type {(inputs: Nfp_Faq_1_AInputs) => LocalizedString} */
const it_nfp_faq_1_a = en_nfp_faq_1_a;

/** @type {(inputs: Nfp_Faq_1_AInputs) => LocalizedString} */
const ru_nfp_faq_1_a = en_nfp_faq_1_a;

/** @type {(inputs: Nfp_Faq_1_AInputs) => LocalizedString} */
const pt_nfp_faq_1_a = en_nfp_faq_1_a;

/** @type {(inputs: Nfp_Faq_1_AInputs) => LocalizedString} */
const ko_nfp_faq_1_a = en_nfp_faq_1_a;

/**
* | output |
* | --- |
* | "You can launch a fully functional hub on the Base Operator tier with zero monthly fees. We only collect a small platform fee on processed donations or sales." |
*
* @param {Nfp_Faq_1_AInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const nfp_faq_1_a = /** @type {((inputs?: Nfp_Faq_1_AInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nfp_Faq_1_AInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nfp_faq_1_a(inputs)
	if (locale === "es") return es_nfp_faq_1_a(inputs)
	if (locale === "fr") return fr_nfp_faq_1_a(inputs)
	if (locale === "de") return de_nfp_faq_1_a(inputs)
	if (locale === "ja") return ja_nfp_faq_1_a(inputs)
	if (locale === "zh") return zh_nfp_faq_1_a(inputs)
	if (locale === "ar") return ar_nfp_faq_1_a(inputs)
	if (locale === "id") return id_nfp_faq_1_a(inputs)
	if (locale === "it") return it_nfp_faq_1_a(inputs)
	if (locale === "ru") return ru_nfp_faq_1_a(inputs)
	if (locale === "pt") return pt_nfp_faq_1_a(inputs)
	return ko_nfp_faq_1_a(inputs)
});